module.exports = __webpack_public_path__ + "assets/img/ZT6250-M.c08819ec.png";